import { render, staticRenderFns } from "./DuoUserResetPasswordRedirectHandler.vue?vue&type=template&id=57adbea6&"
import script from "./DuoUserResetPasswordRedirectHandler.vue?vue&type=script&lang=ts&"
export * from "./DuoUserResetPasswordRedirectHandler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports